import { Injectable, inject } from '@angular/core';
import { Tooth } from '@modules/teeth-diagram/models/tooth';
import { BRIDGE_VALIDATION_ERRORS } from '../models/consts';
import { IntuitiveBridge, IntuitiveBridgeValidationErrors } from '../models/intuitive-bridge';
import { RxIntuitiveBridgeService } from './rx-intuitive-bridge-service';
import { RxIntuitiveIndicationRulesService } from './rx-intuitive-indication-rules.service';

@Injectable({ providedIn: 'root' })
export class RxIntuitiveBridgeValidationService {
	private readonly bridgeService = inject(RxIntuitiveBridgeService);
	private readonly indicationsService = inject(RxIntuitiveIndicationRulesService);

	isDefaultBridgeIndication(tooth: Tooth): boolean {
		const indication = this.indicationsService.getBridgeIndicationForDiagram(tooth);

		return this.indicationsService.isDefaultIndication(indication);
	}

	validateBridge(bridge: IntuitiveBridge): IntuitiveBridgeValidationErrors {
		const result: IntuitiveBridgeValidationErrors = {
			teeth: {},
			summary: []
		};

		if (!this.bridgeService.canSaveBridgeTeeth(bridge)) {
			result.summary.push(BRIDGE_VALIDATION_ERRORS.invalidSpanWarning);
		}

		bridge.teeth.forEach(t => {
			if (t.ToothID != null && this.isDefaultBridgeIndication(t)) {
				result.teeth[t.ToothID] = [BRIDGE_VALIDATION_ERRORS.regularWarning];
				result.summary.push(BRIDGE_VALIDATION_ERRORS.regularWarning);
			}
		});

		return result;
	}
}
